import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib/cn';
import { type InputVariants, inputVariants } from './input-variants';

type InputProps = Omit<ComponentProps<'input'>, 'size'> & InputVariants;

export function Input({ size, isMono, className, ...props }: InputProps) {
  return (
    <input
      data-slot="input"
      className={cn(inputVariants({ size, isMono }), className)}
      {...props}
    />
  );
}
